import { SelectionItem } from "../selection-item";
import { SelectionEvent } from "../SelectionEvent";
import { SelectionEventType } from "../SelectionEventType";

export class SelectionStrategySelectFirstLeafIfOnlyOne {

    static syncSelectionItems(values: any[], selectionItems: SelectionItem[], compare: (a, b) => boolean, preSelected = false): boolean {
        {
            let selectionFound = false;
            selectionItems.forEach(si => {
                if (si.children) {
                    this.syncSelectionItems(values, si.children, compare, si.selected);
                }

                if (values.some(v => compare(v, si.value))) {
                    si.selected = true;
                    selectionFound = true;
                } else {
                    si.selected = false;
                }
            });
            return selectionFound;
        }
    }

    static handleParents(item: SelectionItem, triggerItem: SelectionItem, events: SelectionEvent[]): SelectionEvent[] {

        if (triggerItem.selected) {
            if (!item.selected) {
                item.selected = true;
                events.push(new SelectionEvent(SelectionEventType.Checked, item.value));
            }
        }
        return events;
    }

    static toggleTree(items: SelectionItem[], value: boolean): SelectionEvent[] {
        const events = [];
        // eslint-disable-next-line sonarjs/cognitive-complexity
        items.forEach(i => {
            if (i.children) {
                // eslint-disable-next-line eqeqeq
                if (i.selected != undefined && i.selected !== value) {
                    i.selected = value;
                    i.expanded = value;
                    events.push(new SelectionEvent(value ? SelectionEventType.Checked : SelectionEventType.Unchecked, i.value));
                }

                events.push(...this.toggleTree(i.children, value));

            } else if (!i.children) {
                // eslint-disable-next-line eqeqeq
                if (i.selected != undefined && i.selected !== value) {
                    if (value && items.length === 1) {
                        i.selected = true;
                        i.expanded = true;
                        events.push(new SelectionEvent(SelectionEventType.Checked, i.value));
                    } else if (!value) {
                        i.selected = value;
                        i.expanded = value;
                        events.push(new SelectionEvent(value ? SelectionEventType.Checked : SelectionEventType.Unchecked, i.value));
                    }
                }
            }
        });

        return events;
    }

    static onToggle(showing: boolean, items: SelectionItem[]) {
        if (showing) {
            items.forEach(x => {
                if (x.selected) {
                    x.expanded = true;
                }

                if (x.children) {
                    this.onToggle(showing, x.children);
                }
            });
        }
    }
}
